// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// https://polygonscan.com/address/0xc907E116054Ad103354f2D350FD2514433D57F6f
export const BTC__USD = '0xc907E116054Ad103354f2D350FD2514433D57F6f';

// https://polygonscan.com/address/0xDE31F8bFBD8c84b5360CFACCa3539B938dd78ae6
export const WBTC__USD = '0xDE31F8bFBD8c84b5360CFACCa3539B938dd78ae6';

// https://polygonscan.com/address/0xD2D1BdD220C35C27f70a2bE1eD6462cECAc76384
export const VanEck_SMH_MID_iNAV = '0xD2D1BdD220C35C27f70a2bE1eD6462cECAc76384';

// https://polygonscan.com/address/0x8CE3cAc0E6635ce04783709ca3CC4F5fc5304299
export const SGD__USD = '0x8CE3cAc0E6635ce04783709ca3CC4F5fc5304299';

// https://polygonscan.com/address/0x5D16dE6F2b0346362186504645808C976158Bd22
export const VanEck_SMH_EU_MarketStatus = '0x5D16dE6F2b0346362186504645808C976158Bd22';

// https://polygonscan.com/address/0x218231089Bebb2A31970c3b77E96eCfb3BA006D1
export const PHP__USD = '0x218231089Bebb2A31970c3b77E96eCfb3BA006D1';

// https://polygonscan.com/address/0x2A5e28b4F9Ecb01807CeEC25F7b0fcCafF3F6721
export const wstPOL_POL_Exchange_Rate = '0x2A5e28b4F9Ecb01807CeEC25F7b0fcCafF3F6721';

// https://polygonscan.com/address/0x461c7B8D370a240DdB46B402748381C3210136b3
export const XAG__USD = '0x461c7B8D370a240DdB46B402748381C3210136b3';

// https://polygonscan.com/address/0x5ec151834040B4D453A1eA46aA634C1773b36084
export const CVX__USD = '0x5ec151834040B4D453A1eA46aA634C1773b36084';

// https://polygonscan.com/address/0xA1CbF3Fe43BC3501e3Fc4b573e822c70e76A7512
export const MANA__USD = '0xA1CbF3Fe43BC3501e3Fc4b573e822c70e76A7512';

// https://polygonscan.com/address/0x0C466540B2ee1a31b441671eac0ca886e051E410
export const XAU__USD = '0x0C466540B2ee1a31b441671eac0ca886e051E410';

// https://polygonscan.com/address/0xe638249AF9642CdA55A92245525268482eE4C67b
export const GHST__ETH = '0xe638249AF9642CdA55A92245525268482eE4C67b';

// https://polygonscan.com/address/0xAB594600376Ec9fD91F8e885dADF0CE036862dE0
export const MATIC__USD = '0xAB594600376Ec9fD91F8e885dADF0CE036862dE0';

// https://polygonscan.com/address/0x59161117086a4C7A9beDA16C66e40Bdaa1C5a8B6
export const DODO__USD = '0x59161117086a4C7A9beDA16C66e40Bdaa1C5a8B6';

// https://polygonscan.com/address/0x162d8c5bF15eB6BEe003a1ffc4049C92114bc931
export const UNI__ETH = '0x162d8c5bF15eB6BEe003a1ffc4049C92114bc931';

// https://polygonscan.com/address/0x6a99EC84819FB7007dd5D032068742604E755c56
export const WOO__USD = '0x6a99EC84819FB7007dd5D032068742604E755c56';

// https://polygonscan.com/address/0xC43081d9EA6d1c53f1F0e525504d47Dd60de12da
export const MSFT__USD = '0xC43081d9EA6d1c53f1F0e525504d47Dd60de12da';

// https://polygonscan.com/address/0x24B820870F726dA9B0D83B0B28a93885061dbF50
export const KRW__USD = '0x24B820870F726dA9B0D83B0B28a93885061dbF50';

// https://polygonscan.com/address/0xc86105DccF9BD629Cea7Fd41f94c6050bF96D57F
export const OM__USD = '0xc86105DccF9BD629Cea7Fd41f94c6050bF96D57F';

// https://polygonscan.com/address/0x7899dd75C329eFe63e35b02bC7d60D3739FB23c5
export const KAVA__USD = '0x7899dd75C329eFe63e35b02bC7d60D3739FB23c5';

// https://polygonscan.com/address/0x7C5D415B64312D38c56B54358449d0a4058339d2
export const TUSD__USD = '0x7C5D415B64312D38c56B54358449d0a4058339d2';

// https://polygonscan.com/address/0xf9184b8E5da48C19fA4E06f83f77742e748cca96
export const AMZN__USD = '0xf9184b8E5da48C19fA4E06f83f77742e748cca96';

// https://polygonscan.com/address/0xbaf9327b6564454F4a3364C33eFeEf032b4b4444
export const DOGE__USD = '0xbaf9327b6564454F4a3364C33eFeEf032b4b4444';

// https://polygonscan.com/address/0x17414Eb5159A082e8d41D243C1601c2944401431
export const SUSHI__ETH = '0x17414Eb5159A082e8d41D243C1601c2944401431';

// https://polygonscan.com/address/0x82a6c4AF830caa6c97bb504425f6A66165C2c26e
export const BNB__USD = '0x82a6c4AF830caa6c97bb504425f6A66165C2c26e';

// https://polygonscan.com/address/0x0fB2beD999da86Cb1Fdd97E746600A96141EeA09
export const bNVDA_Reserves__Proof_of_Reserves = '0x0fB2beD999da86Cb1Fdd97E746600A96141EeA09';

// https://polygonscan.com/address/0xFC539A559e170f848323e19dfD66007520510085
export const DAI__ETH = '0xFC539A559e170f848323e19dfD66007520510085';

// https://polygonscan.com/address/0xa07703E5C2eD1516107c7c72A494493Dcb99C676
export const FIL__USD = '0xa07703E5C2eD1516107c7c72A494493Dcb99C676';

// https://polygonscan.com/address/0x10C8264C0935b3B9870013e057f330Ff3e9C56dC
export const SOL__USD = '0x10C8264C0935b3B9870013e057f330Ff3e9C56dC';

// https://polygonscan.com/address/0x1d22c334621364F16f050076eE15Acd5eb8225Ce
export const COPW_Reserves = '0x1d22c334621364F16f050076eE15Acd5eb8225Ce';

// https://polygonscan.com/address/0xfAA9147190c2C2cc5B8387B4f49016bDB3380572
export const COP__USD = '0xfAA9147190c2C2cc5B8387B4f49016bDB3380572';

// https://polygonscan.com/address/0xa302a0B8a499fD0f00449df0a490DedE21105955
export const NZD__USD = '0xa302a0B8a499fD0f00449df0a490DedE21105955';

// https://polygonscan.com/address/0x2409987e514Ad8B0973C2b90ee1D95051DF0ECB9
export const CHZ__USD = '0x2409987e514Ad8B0973C2b90ee1D95051DF0ECB9';

// https://polygonscan.com/address/0x171b16562EA3476F5C61d1b8dad031DbA0768545
export const MXN__USD = '0x171b16562EA3476F5C61d1b8dad031DbA0768545';

// https://polygonscan.com/address/0x70c69A2756AB7911EbD15DF88E1D4989BC4109d7
export const RDNT__USD = '0x70c69A2756AB7911EbD15DF88E1D4989BC4109d7';

// https://polygonscan.com/address/0xF7F291042F6Cbc4deC0Ad75c17786511a530dbe8
export const QNT__USD = '0xF7F291042F6Cbc4deC0Ad75c17786511a530dbe8';

// https://polygonscan.com/address/0xd9FFdb71EbE7496cC440152d43986Aae0AB76665
export const LINK__USD = '0xd9FFdb71EbE7496cC440152d43986Aae0AB76665';

// https://polygonscan.com/address/0x567E67f456c7453c583B6eFA6F18452cDee1F5a8
export const TSLA__USD = '0x567E67f456c7453c583B6eFA6F18452cDee1F5a8';

// https://polygonscan.com/address/0xbE23a3AA13038CfC28aFd0ECe4FdE379fE7fBfc4
export const AAVE__ETH = '0xbE23a3AA13038CfC28aFd0ECe4FdE379fE7fBfc4';

// https://polygonscan.com/address/0x4517002fCD31062Ea38680dF9Ee37f29528C2707
export const bIBTA_Reserves = '0x4517002fCD31062Ea38680dF9Ee37f29528C2707';

// https://polygonscan.com/address/0xd1d85Bf11c28F878EE75BdC39387a2a15E0390b7
export const sUSDe__USDe_Exchange_Rate = '0xd1d85Bf11c28F878EE75BdC39387a2a15E0390b7';

// https://polygonscan.com/address/0x80a5cb83ce268Ed11a6EFC4bBF0beC39dF35Db21
export const IDR__USD = '0x80a5cb83ce268Ed11a6EFC4bBF0beC39dF35Db21';

// https://polygonscan.com/address/0x73366Fe0AA0Ded304479862808e02506FE556a98
export const EUR__USD = '0x73366Fe0AA0Ded304479862808e02506FE556a98';

// https://polygonscan.com/address/0x10f964234cae09cB6a9854B56FF7D4F38Cda5E6a
export const WSTETH__ETH = '0x10f964234cae09cB6a9854B56FF7D4F38Cda5E6a';

// https://polygonscan.com/address/0x3B21a277babcB73b5a2325106FC04Df8AA1aC5b6
export const USDS__USD = '0x3B21a277babcB73b5a2325106FC04Df8AA1aC5b6';

// https://polygonscan.com/address/0x648E0fF6A36D58F6FCE5927cB77601b73cAdc2Af
export const bC3M_Reserves = '0x648E0fF6A36D58F6FCE5927cB77601b73cAdc2Af';

// https://polygonscan.com/address/0x8d5eB34C509261533235b91350d359EdcB969D33
export const ILS__USD = '0x8d5eB34C509261533235b91350d359EdcB969D33';

// https://polygonscan.com/address/0x307cCF7cBD17b69A487b9C3dbe483931Cf3E1833
export const TRX__USD = '0x307cCF7cBD17b69A487b9C3dbe483931Cf3E1833';

// https://polygonscan.com/address/0x3FabBfb300B1e2D7c9B84512fe9D30aeDF24C410
export const GRT__USD = '0x3FabBfb300B1e2D7c9B84512fe9D30aeDF24C410';

// https://polygonscan.com/address/0xDD229Ce42f11D8Ee7fFf29bDB71C7b81352e11be
export const GHST__USD = '0xDD229Ce42f11D8Ee7fFf29bDB71C7b81352e11be';

// https://polygonscan.com/address/0x187c42f6C0e7395AeA00B1B30CB0fF807ef86d5d
export const SPYUS = '0x187c42f6C0e7395AeA00B1B30CB0fF807ef86d5d';

// https://polygonscan.com/address/0x9199b9dF4519a435b4F515E8B43B5C2df4DD0b8c
export const rcUSDPlus_NAV = '0x9199b9dF4519a435b4F515E8B43B5C2df4DD0b8c';

// https://polygonscan.com/address/0x10e5f3DFc81B3e5Ef4e648C4454D04e79E1E41E2
export const KNC__USD = '0x10e5f3DFc81B3e5Ef4e648C4454D04e79E1E41E2';

// https://polygonscan.com/address/0xEB99F173cf7d9a6dC4D889C2Ad7103e8383b6Efa
export const LTC__USD = '0xEB99F173cf7d9a6dC4D889C2Ad7103e8383b6Efa';

// https://polygonscan.com/address/0x1b32682C033b2DD7EFdC615FA82d353e254F39b5
export const GOOGL__USD = '0x1b32682C033b2DD7EFdC615FA82d353e254F39b5';

// https://polygonscan.com/address/0x3636B780588328dc3F5df075De5627DBc9A6BA10
export const ILV__ETH = '0x3636B780588328dc3F5df075De5627DBc9A6BA10';

// https://polygonscan.com/address/0xad4395fc414Fc1575A7a38C20B0Bfdbdb09ee41A
export const bIB01_Reserves = '0xad4395fc414Fc1575A7a38C20B0Bfdbdb09ee41A';

// https://polygonscan.com/address/0xd4a120c26d57B910C56c910CdD13EeBFA3135502
export const ZAR__USD = '0xd4a120c26d57B910C56c910CdD13EeBFA3135502';

// https://polygonscan.com/address/0xB89D583B72aBF9C3a7e6e093251C2fCad3365312
export const MLN__ETH = '0xB89D583B72aBF9C3a7e6e093251C2fCad3365312';

// https://polygonscan.com/address/0x04bB437Aa63E098236FA47365f0268547f6EAB32
export const CNY__USD = '0x04bB437Aa63E098236FA47365f0268547f6EAB32';

// https://polygonscan.com/address/0xB34BCE11040702f71c11529D00179B2959BcE6C0
export const PLN__USD = '0xB34BCE11040702f71c11529D00179B2959BcE6C0';

// https://polygonscan.com/address/0x03CD157746c61F44597dD54C6f6702105258C722
export const BAL__ETH = '0x03CD157746c61F44597dD54C6f6702105258C722';

// https://polygonscan.com/address/0xF9680D99D6C9589e2a93a78A04A279e509205945
export const ETH__USD = '0xF9680D99D6C9589e2a93a78A04A279e509205945';

// https://polygonscan.com/address/0xc3E676E68dB28c9Fb2199f25B60560723237cc76
export const ibBTC_PricePerShare = '0xc3E676E68dB28c9Fb2199f25B60560723237cc76';

// https://polygonscan.com/address/0x2A8758b7257102461BC958279054e372C2b1bDE6
export const COMP__USD = '0x2A8758b7257102461BC958279054e372C2b1bDE6';

// https://polygonscan.com/address/0xed7051d55eeaF85E36053D6b0f2C51E59625B047
export const TRUMATIC__MATIC_Exchange_Rate = '0xed7051d55eeaF85E36053D6b0f2C51E59625B047';

// https://polygonscan.com/address/0x9d3A43c111E7b2C6601705D9fcF7a70c95b1dc55
export const YFI__USD = '0x9d3A43c111E7b2C6601705D9fcF7a70c95b1dc55';

// https://polygonscan.com/address/0x0f6914d8e7e1214CDb3A4C6fbf729b75C69DF608
export const PAXG__USD = '0x0f6914d8e7e1214CDb3A4C6fbf729b75C69DF608';

// https://polygonscan.com/address/0x5787BefDc0ECd210Dfa948264631CD53E68F7802
export const LINK__MATIC = '0x5787BefDc0ECd210Dfa948264631CD53E68F7802';

// https://polygonscan.com/address/0xA338e0492B2F944E9F8C0653D3AD1484f2657a37
export const WBTC__ETH = '0xA338e0492B2F944E9F8C0653D3AD1484f2657a37';

// https://polygonscan.com/address/0x062Df9C4efd2030e243ffCc398b652e8b8F95C6f
export const AUD__USD = '0x062Df9C4efd2030e243ffCc398b652e8b8F95C6f';

// https://polygonscan.com/address/0x864377d3620da9d42451f98674593e067a997308
export const MaticX__POL_Exchange_Rate = '0x864377d3620da9d42451f98674593e067a997308';

// https://polygonscan.com/address/0xd8d483d813547CfB624b8Dc33a00F2fcbCd2D428
export const MIMATIC__USD = '0xd8d483d813547CfB624b8Dc33a00F2fcbCd2D428';

// https://polygonscan.com/address/0xacb51F1a83922632ca02B25a8164c10748001BdE
export const DOT__USD = '0xacb51F1a83922632ca02B25a8164c10748001BdE';

// https://polygonscan.com/address/0xBE6FB0AB6302B693368D0E9001fAF77ecc6571db
export const XMR__USD = '0xBE6FB0AB6302B693368D0E9001fAF77ecc6571db';

// https://polygonscan.com/address/0xDA0F8Df6F5dB15b346f4B8D1156722027E194E60
export const INR__USD = '0xDA0F8Df6F5dB15b346f4B8D1156722027E194E60';

// https://polygonscan.com/address/0x5164Ad28fb12a5e55946090Ec3eE1B748AFb3785
export const THB__USD = '0x5164Ad28fb12a5e55946090Ec3eE1B748AFb3785';

// https://polygonscan.com/address/0x0A6513e40db6EB1b165753AD52E80663aeA50545
export const USDT__USD = '0x0A6513e40db6EB1b165753AD52E80663aeA50545';

// https://polygonscan.com/address/0xD106B538F2A868c28Ca1Ec7E298C3325E0251d66
export const BAL__USD = '0xD106B538F2A868c28Ca1Ec7E298C3325E0251d66';

// https://polygonscan.com/address/0x691e26AB58ff05800E028b0876A41B720b26FC65
export const XTZ__USD = '0x691e26AB58ff05800E028b0876A41B720b26FC65';

// https://polygonscan.com/address/0x3Ea1eC855fBda8bA0396975eC260AD2e9B2Bc01c
export const wstETH_stETH_Exchange_Rate = '0x3Ea1eC855fBda8bA0396975eC260AD2e9B2Bc01c';

// https://polygonscan.com/address/0xDAFA1989A504c48Ee20a582f2891eeB25E2fA23F
export const AAVE_Network_Emergency_Count_Polygon = '0xDAFA1989A504c48Ee20a582f2891eeB25E2fA23F';

// https://polygonscan.com/address/0x76631863c2ae7367aF8f37Cd10d251DA7f1DE186
export const XPT__USD = '0x76631863c2ae7367aF8f37Cd10d251DA7f1DE186';

// https://polygonscan.com/address/0x785ba89291f676b5386652eB12b30cF361020694
export const XRP__USD = '0x785ba89291f676b5386652eB12b30cF361020694';

// https://polygonscan.com/address/0xAc4193Cf0F28937f54BaB591e5FBdeB5c5D05a2f
export const YBTC_BTC_Exchange_Rate = '0xAc4193Cf0F28937f54BaB591e5FBdeB5c5D05a2f';

// https://polygonscan.com/address/0x6b20c92A1D73A9232383DEcD698Ff559eFa0c31A
export const RYT_Polygon_Proof_of_Reserves = '0x6b20c92A1D73A9232383DEcD698Ff559eFa0c31A';

// https://polygonscan.com/address/0xe71A04ACe06e2667c7e1c802E998CBf44A6bf53C
export const sUSDe__USD = '0xe71A04ACe06e2667c7e1c802E998CBf44A6bf53C';

// https://polygonscan.com/address/0xACA44ABb8B04D07D883202F99FA5E3c53ed57Fb5
export const CAD__USD = '0xACA44ABb8B04D07D883202F99FA5E3c53ed57Fb5';

// https://polygonscan.com/address/0xB90DA3ff54C3ED09115abf6FbA0Ff4645586af2c
export const BRL__USD = '0xB90DA3ff54C3ED09115abf6FbA0Ff4645586af2c';

// https://polygonscan.com/address/0xdf0Fb4e4F928d2dCB76f438575fDD8682386e13C
export const UNI__USD = '0xdf0Fb4e4F928d2dCB76f438575fDD8682386e13C';

// https://polygonscan.com/address/0xd78325DcA0F90F0FFe53cCeA1B02Bb12E1bf8FdB
export const TRY__USD = '0xd78325DcA0F90F0FFe53cCeA1B02Bb12E1bf8FdB';

// https://polygonscan.com/address/0x718Bc433B74C591EBAfC13703CD9bDfcffD5B2A9
export const YETH_ETH_Exchange_Rate = '0x718Bc433B74C591EBAfC13703CD9bDfcffD5B2A9';

// https://polygonscan.com/address/0xbF90A5D9B6EE9019028dbFc2a9E50056d5252894
export const SNX__USD = '0xbF90A5D9B6EE9019028dbFc2a9E50056d5252894';

// https://polygonscan.com/address/0x6C0fe985D3cAcbCdE428b84fc9431792694d0f51
export const FXS__USD = '0x6C0fe985D3cAcbCdE428b84fc9431792694d0f51';

// https://polygonscan.com/address/0x2Ac3F3Bfac8fC9094BC3f0F9041a51375235B992
export const APE__USD = '0x2Ac3F3Bfac8fC9094BC3f0F9041a51375235B992';

// https://polygonscan.com/address/0xf9d5AAC6E5572AEFa6bd64108ff86a222F69B64d
export const USDT__ETH = '0xf9d5AAC6E5572AEFa6bd64108ff86a222F69B64d';

// https://polygonscan.com/address/0x9c371aE34509590E10aB98205d2dF5936A1aD875
export const AXS__USD = '0x9c371aE34509590E10aB98205d2dF5936A1aD875';

// https://polygonscan.com/address/0x9896A1eA7A00F5f32Ab131eBbeE07487B0af31D0
export const YFI__ETH = '0x9896A1eA7A00F5f32Ab131eBbeE07487B0af31D0';

// https://polygonscan.com/address/0x72484B12719E23115761D5DA1646945632979bB6
export const AAVE__USD = '0x72484B12719E23115761D5DA1646945632979bB6';

// https://polygonscan.com/address/0xbd92B4919ae82be8473859295dEF0e778A626302
export const SEK__USD = '0xbd92B4919ae82be8473859295dEF0e778A626302';

// https://polygonscan.com/address/0x49B0c695039243BBfEb8EcD054EB70061fd54aa0
export const SUSHI__USD = '0x49B0c695039243BBfEb8EcD054EB70061fd54aa0';

// https://polygonscan.com/address/0x0a6a03CdF7d0b48d4e4BA8e362A4FfC3aAC4f3c0
export const CBETH__ETH = '0x0a6a03CdF7d0b48d4e4BA8e362A4FfC3aAC4f3c0';

// https://polygonscan.com/address/0x4e9fc7480c16F3FE5d956C0759eE6b4808d1F5D7
export const CGT_Proof_of_Reserves_ETH = '0x4e9fc7480c16F3FE5d956C0759eE6b4808d1F5D7';

// https://polygonscan.com/address/0x336584C8E6Dc19637A5b36206B1c79923111b405
export const CRV__USD = '0x336584C8E6Dc19637A5b36206B1c79923111b405';

// https://polygonscan.com/address/0x38611b09F8f2D520c14eA973765C225Bf57B9Eac
export const THETA__USD = '0x38611b09F8f2D520c14eA973765C225Bf57B9Eac';

// https://polygonscan.com/address/0xefb7e6be8356cCc6827799B6A7348eE674A80EaE
export const USDC__ETH = '0xefb7e6be8356cCc6827799B6A7348eE674A80EaE';

// https://polygonscan.com/address/0x327d9822e9932996f55b39F557AEC838313da8b7
export const BCH__USD = '0x327d9822e9932996f55b39F557AEC838313da8b7';

// https://polygonscan.com/address/0x817A7D43f0277Ca480AE03Ec76Fc63A2EC7114bA
export const FTT__USD = '0x817A7D43f0277Ca480AE03Ec76Fc63A2EC7114bA';

// https://polygonscan.com/address/0xD647a6fC9BC6402301583C91decC5989d8Bc382D
export const JPY__USD = '0xD647a6fC9BC6402301583C91decC5989d8Bc382D';

// https://polygonscan.com/address/0x97371dF4492605486e23Da797fA68e55Fc38a13f
export const Calculated_stMATIC__USD = '0x97371dF4492605486e23Da797fA68e55Fc38a13f';

// https://polygonscan.com/address/0xD94427eDee70E4991b4b8DdCc848f2B58ED01C0b
export const DASH__USD = '0xD94427eDee70E4991b4b8DdCc848f2B58ED01C0b';

// https://polygonscan.com/address/0x00DBeB1e45485d53DF7C2F0dF1Aa0b6Dc30311d3
export const FRAX__USD = '0x00DBeB1e45485d53DF7C2F0dF1Aa0b6Dc30311d3';

// https://polygonscan.com/address/0xBB3eF70953fC3766bec4Ab7A9BF05B6E4caf89c6
export const SLP__USD = '0xBB3eF70953fC3766bec4Ab7A9BF05B6E4caf89c6';

// https://polygonscan.com/address/0x3710abeb1A0Fc7C2EC59C26c8DAA7a448ff6125A
export const SHIB__USD = '0x3710abeb1A0Fc7C2EC59C26c8DAA7a448ff6125A';

// https://polygonscan.com/address/0x3D49406EDd4D52Fb7FFd25485f32E073b529C924
export const SAND__USD = '0x3D49406EDd4D52Fb7FFd25485f32E073b529C924';

// https://polygonscan.com/address/0x19b0F0833C78c0848109E3842D34d2fDF2cA69BA
export const BTC__ETH = '0x19b0F0833C78c0848109E3842D34d2fDF2cA69BA';

// https://polygonscan.com/address/0x2346Ce62bd732c62618944E51cbFa09D985d86D2
export const BAT__USD = '0x2346Ce62bd732c62618944E51cbFa09D985d86D2';

// https://polygonscan.com/address/0xe01eA2fbd8D76ee323FbEd03eB9a8625EC981A10
export const AVAX__USD = '0xe01eA2fbd8D76ee323FbEd03eB9a8625EC981A10';

// https://polygonscan.com/address/0x327e23A4855b6F663a28c5161541d69Af8973302
export const MATIC__ETH = '0x327e23A4855b6F663a28c5161541d69Af8973302';

// https://polygonscan.com/address/0x443C5116CdF663Eb387e72C688D276e702135C87
export const _1INCH__USD = '0x443C5116CdF663Eb387e72C688D276e702135C87';

// https://polygonscan.com/address/0x5c3890e86f3E7Ed7F5390532De147953580f1605
export const USDe__USD = '0x5c3890e86f3E7Ed7F5390532De147953580f1605';

// https://polygonscan.com/address/0xF626964Ba5e81405f47e8004F0b276Bb974742B5
export const BADGER__USD = '0xF626964Ba5e81405f47e8004F0b276Bb974742B5';

// https://polygonscan.com/address/0x692AE5510cA9070095A496dbcFBCDA99D4024Cd9
export const XLM__USD = '0x692AE5510cA9070095A496dbcFBCDA99D4024Cd9';

// https://polygonscan.com/address/0x55e75d35c44A9EE1A5b05416640965EbcA4a8D33
export const bCSPX_Reserves = '0x55e75d35c44A9EE1A5b05416640965EbcA4a8D33';

// https://polygonscan.com/address/0xDf3f72Be10d194b58B1BB56f2c4183e661cB2114
export const ETC__USD = '0xDf3f72Be10d194b58B1BB56f2c4183e661cB2114';

// https://polygonscan.com/address/0x03Bc6D9EFed65708D35fDaEfb25E87631a0a3437
export const ALGO__USD = '0x03Bc6D9EFed65708D35fDaEfb25E87631a0a3437';

// https://polygonscan.com/address/0x0F1d5Bd7be9B30Fc09E110cd6504Bd450e53cb0E
export const STORJ__USD = '0x0F1d5Bd7be9B30Fc09E110cd6504Bd450e53cb0E';

// https://polygonscan.com/address/0xC5878bDf8a89FA3bF0DC8389ae8EE6DE601D01bC
export const HBAR__USD = '0xC5878bDf8a89FA3bF0DC8389ae8EE6DE601D01bC';

// https://polygonscan.com/address/0xfE4A8cc5b5B2366C1B58Bea3858e81843581b2F7
export const USDC__USD = '0xfE4A8cc5b5B2366C1B58Bea3858e81843581b2F7';

// https://polygonscan.com/address/0x099a2540848573e94fb1Ca0Fa420b00acbBc845a
export const GBP__USD = '0x099a2540848573e94fb1Ca0Fa420b00acbBc845a';

// https://polygonscan.com/address/0x7E7B45b08F68EC69A99AAb12e42FcCB078e10094
export const AAPL__USD = '0x7E7B45b08F68EC69A99AAb12e42FcCB078e10094';

// https://polygonscan.com/address/0x5DB6e61B6159B20F068dc15A47dF2E5931b14f29
export const ALCX__USD = '0x5DB6e61B6159B20F068dc15A47dF2E5931b14f29';

// https://polygonscan.com/address/0x882554df528115a743c4537828DA8D5B58e52544
export const ADA__USD = '0x882554df528115a743c4537828DA8D5B58e52544';

// https://polygonscan.com/address/0x4746DeC9e833A82EC7C2C1356372CcF2cfcD2F3D
export const DAI__USD = '0x4746DeC9e833A82EC7C2C1356372CcF2cfcD2F3D';

// https://polygonscan.com/address/0xb77fa460604b9C6435A235D057F7D319AC83cb53
export const LINK__ETH = '0xb77fa460604b9C6435A235D057F7D319AC83cb53';

// https://polygonscan.com/address/0xBC08c639e579a391C4228F20d0C29d0690092DF0
export const ZEC__USD = '0xBC08c639e579a391C4228F20d0C29d0690092DF0';

// https://polygonscan.com/address/0x33D9B1BAaDcF4b26ab6F8E83e9cb8a611B2B3956
export const UMA__USD = '0x33D9B1BAaDcF4b26ab6F8E83e9cb8a611B2B3956';

// https://polygonscan.com/address/0x1CF68C76803c9A415bE301f50E82e44c64B7F1D4
export const CRV__ETH = '0x1CF68C76803c9A415bE301f50E82e44c64B7F1D4';

// https://polygonscan.com/address/0x5d37E4b374E6907de8Fc7fb33EE3b0af403C7403
export const Calculated_MaticX__USD = '0x5d37E4b374E6907de8Fc7fb33EE3b0af403C7403';

// https://polygonscan.com/address/0xdefcBDC0a5f5fBBdF520dC97be8d6d025B18da05
export const RYT_NAV = '0xdefcBDC0a5f5fBBdF520dC97be8d6d025B18da05';

// https://polygonscan.com/address/0x84227A76a04289473057BEF706646199D7C58c34
export const ICP__USD = '0x84227A76a04289473057BEF706646199D7C58c34';

// https://polygonscan.com/address/0xc76f762CedF0F78a439727861628E0fdfE1e70c2
export const CHF__USD = '0xc76f762CedF0F78a439727861628E0fdfE1e70c2';

export const CHAIN_ID = 137;
